module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_0.99183f2e.png";